export default {
  'login.title': 'MyStorageX',
  'login.welcome': 'مرحباً بك في MyStorageX',
  'login.description': 'MyStorageX هو مساعدك في التخزين السحابي، يوفر تخزين وإدارة آمنة ومريحة للملفات. الوصول إلى ملفاتك في أي وقت وأي مكان.',
  'login.email.placeholder': 'البريد الإلكتروني أو اسم المستخدم',
  'login.password.placeholder': 'كلمة المرور',
  'login.button': 'تسجيل الدخول',
  'login.loading': 'جاري تسجيل الدخول...',
  'login.divider': 'أو',
  'login.signup': 'ليس لديك حساب؟',
  'login.signup.link': 'سجل الآن',
  'login.error.default': 'فشل تسجيل الدخول، يرجى المحاولة لاحقاً',
  'login.success': 'تم تسجيل الدخول',
  'login.forgotPassword': 'نسيت كلمة المرور؟',
  'login.forgotPassword.link': 'إعادة تعيين هنا',
  'signup.page.title': 'التسجيل - MyStorageX',
  'signup.title': 'MyStorageX',
  'signup.welcome': 'مرحباً بك في MyStorageX',
  'signup.description': 'أنشئ حسابك وابدأ رحلة التخزين السحابي',
  'signup.username.placeholder': 'أدخل اسم المستخدم',
  'signup.email.placeholder': 'أدخل البريد الإلكتروني',
  'signup.password.placeholder': 'أدخل كلمة المرور',
  'signup.confirmPassword.placeholder': 'تأكيد كلمة المرور',
  'signup.button': 'تسجيل',
  'signup.loading': 'جاري التسجيل...',
  'signup.login': 'لديك حساب بالفعل؟',
  'signup.login.link': 'تسجيل الدخول',
  'signup.error.passwordMismatch': 'كلمات المرور غير متطابقة',
  'signup.error.default': 'فشل التسجيل، يرجى المحاولة لاحقاً',
  'signup.success': 'تم التسجيل بنجاح',
  'signup.username.rule.length': 'يجب أن يكون اسم المستخدم بين 4 و 10 أحرف',
  'signup.username.rule.format': 'يُسمح فقط بالحروف والأرقام والشرطات السفلية والواصلات',
  'signup.password.rule.length': 'يجب أن تكون كلمة المرور بين 6 و 20 حرفاً',
  'signup.password.rule.lowercase': 'يجب أن تحتوي على أحرف صغيرة',
  'signup.password.rule.uppercase': 'يجب أن تحتوي على أحرف كبيرة',
  'signup.password.rule.number': 'يجب أن تحتوي على أرقام',
  'signup.password.rule.special': 'يجب أن تحتوي على رموز خاصة',
  'resetPassword.page.title': 'إعادة تعيين كلمة المرور - MyStorageX',
  'resetPassword.page.description': 'إعادة تعيين كلمة مرور حسابك في MyStorageX',
  'resetPassword.title': 'إعادة تعيين كلمة المرور',
  'resetPassword.email.placeholder': 'أدخل عنوان بريدك الإلكتروني',
  'resetPassword.code.placeholder': 'أدخل رمز التحقق',
  'resetPassword.password.placeholder': 'أدخل كلمة المرور الجديدة',
  'resetPassword.button': 'إعادة تعيين',
  'resetPassword.button.loading': 'جاري إعادة التعيين...',
  'resetPassword.backToLogin': 'العودة إلى تسجيل الدخول',
  'resetPassword.sendCode': 'الحصول على الرمز',
  'resetPassword.sendCode.sending': 'جاري الإرسال...',
  'resetPassword.sendCode.retry': 'أعد المحاولة بعد {seconds} ثانية',
  'resetPassword.error.emailRequired': 'الرجاء إدخال عنوان بريدك الإلكتروني',
  'resetPassword.error.codeRequired': 'الرجاء إدخال رمز التحقق',
  'resetPassword.error.passwordRequired': 'الرجاء إدخال كلمة المرور الجديدة',
  'resetPassword.error.passwordLength': 'يجب أن تكون كلمة المرور بين 6 و 20 حرفاً',
  'resetPassword.error.codeLength': 'يجب أن يتكون رمز التحقق من 6 أرقام',
  'resetPassword.success.codeSent': 'تم إرسال رمز التحقق إلى بريدك الإلكتروني',
  'resetPassword.success.reset': 'تم إعادة تعيين كلمة المرور بنجاح',
  'resetPassword.error.sendFailed': 'فشل في إرسال رمز التحقق، يرجى المحاولة لاحقاً',
  'resetPassword.error.resetFailed': 'فشل في إعادة تعيين كلمة المرور، يرجى المحاولة لاحقاً',
  'signup.verificationCode.placeholder': 'أدخل رمز التحقق',
  'signup.verificationCode.send': 'الحصول على الرمز',
  'signup.verificationCode.sending': 'جاري الإرسال...',
  'signup.verificationCode.retry': 'أعد المحاولة بعد {seconds} ثانية',
  'signup.verificationCode.success': 'تم إرسال رمز التحقق',
  'signup.verificationCode.error': 'فشل في إرسال الرمز',
  'signup.verificationCode.required': 'الرجاء إدخال رمز التحقق',
  'signup.verificationCode.invalid': 'تنسيق رمز التحقق غير صالح',
  'signup.error.emailRequired': 'الرجاء إدخال عنوان بريدك الإلكتروني',
  'signup.announcement': 'وظيفة التسجيل قيد الصيانة اليوم!',
  'sidebar.allFiles': 'جميع الملفات',
  'sidebar.starred': 'المفضلة',
  'sidebar.folders': 'المجلدات',
  'sidebar.trash': 'سلة المهملات',
  'sidebar.decrypt': 'أداة فك التشفير',
  'sidebar.feedback': 'الملاحظات',
  'sidebar.about': 'حول',
  'sidebar.productLog': 'التحديثات',
  'filelist.column.name': 'الاسم',
  'filelist.column.size': 'الحجم',
  'filelist.column.updateTime': 'تاريخ التعديل',
  'filelist.column.recycletime': 'تاريخ الحذف',
  'filelist.column.actions': 'الإجراءات',
  'filelist.total': 'إجمالي {total} عنصر',
  'filelist.action.upload': 'رفع',
  'filelist.action.newFolder': 'مجلد جديد',
  'filelist.action.refresh': 'تحديث',
  'filelist.action.search': 'بحث عن الملفات',
  'filelist.action.batchDownload': 'تنزيل',
  'filelist.action.batchDelete': 'حذف',
  'filelist.action.download': 'تنزيل',
  'filelist.action.preview': 'معاينة',
  'filelist.action.rename': 'إعادة تسمية',
  'filelist.selected': 'تم اختيار {count}',
  'page.cloudDrive.title': 'Cloud Drive الخاص بي',
  'page.cloudDrive.description': 'MyStorageX Cloud Drive - قم بتخزين وإدارة ملفاتك بأمان',
  'modal.fileUpload.title': 'رفع الملفات',
  'modal.fileUpload.dragText': 'اسحب الملفات هنا أو انقر للرفع',
  'modal.fileUpload.start': 'بدء الرفع',
  'modal.fileUpload.cancel': 'إلغاء',
  'modal.fileUpload.clear': 'مسح القائمة',
  'modal.fileUpload.encrypt': 'تشفير المحدد',
  'modal.fileUpload.addMore': 'إضافة',
  'modal.fileUpload.remove': 'إزالة',
  'modal.fileUpload.error.noSelection': 'يرجى اختيار الملفات للإزالة',
  'modal.fileUpload.error.noEncryption': 'يرجى اختيار الملفات للتشفير',
  'modal.fileUpload.error.noClear': 'لا توجد ملفات للمسح',
  'modal.fileUpload.error.noStart': 'لا توجد ملفات للرفع',
  'modal.fileUpload.error.noCancel': 'لا توجد عمليات رفع نشطة للإلغاء',
  'modal.fileUpload.error.fileSize': 'تم تجاوز حجم الملف',
  'modal.fileUpload.error.fileType': 'نوع الملف غير مدعوم',
  'modal.fileUpload.error.maxCount': 'تم تجاوز الحد الأقصى لعدد الملفات',
  'modal.fileUpload.duplicate.title': 'الملف موجود بالفعل',
  'modal.fileUpload.duplicate.skip': 'تخطي',
  'modal.fileUpload.duplicate.replace': 'استبدال',
  'modal.fileUpload.duplicate.rename': 'إعادة تسمية',
  'modal.fileUpload.status.pending': 'قيد الانتظار',
  'modal.fileUpload.status.uploading': 'جاري الرفع',
  'modal.fileUpload.status.success': 'تم الإكمال',
  'modal.fileUpload.status.error': 'خطأ',
  'modal.fileUpload.status.cancelled': 'تم الإلغاء',
  'modal.fileUpload.status.duplicated': 'مكرر',
  'modal.fileUpload.table.filename': 'اسم الملف',
  'modal.fileUpload.table.size': 'الحجم',
  'modal.fileUpload.table.status': 'الحالة',
  'modal.fileUpload.table.progress': 'التقدم',
  'modal.fileUpload.table.actions': 'الإجراءات',
  'modal.fileUpload.speed': 'سرعة الرفع',
  'modal.fileUpload.remainingTime': 'الوقت المتبقي',
  'modal.fileUpload.total.progress': 'التقدم الكلي',
  'modal.fileUpload.error.message': 'خطأ في الرفع: {message}',
  'modal.fileUpload.confirm.clear': 'هل تريد مسح قائمة الرفع؟',
  'modal.fileUpload.confirm.cancel': 'هل تريد إلغاء الرفع؟',
  'modal.fileUpload.clear.mobile': 'مسح',
  'modal.fileUpload.encrypt.mobile': 'تشفير',
  'modal.fileUpload.addMore.mobile': 'إضافة',
  'modal.newFolder.title': 'مجلد جديد',
  'modal.newFolder.placeholder': 'أدخل اسم المجلد',
  'modal.newFolder.ok': 'إنشاء',
  'modal.newFolder.cancel': 'إلغاء',
  'filelist.modal.rename.title': 'إعادة تسمية',
  'filelist.modal.rename.placeholder': 'أدخل الاسم الجديد',
  'filelist.modal.rename.ok': 'موافق',
  'filelist.modal.rename.cancel': 'إلغاء',
  'productLog.title': 'تحديثات المنتج',
  'page.decrypt.title': 'أداة فك تشفير الملفات MyStorage',
  'page.decrypt.subtitle': 'قم بفك تشفير ملفاتك بأمان',
  'page.decrypt.helmet.title': 'أداة فك التشفير - MyStorage',
  'page.decrypt.helmet.description': 'أداة فك تشفير آمنة - قم بفك تشفير ملفاتك محلياً في المتصفح لحماية خصوصيتك',
  'decrypt.upload.dragText': 'انقر أو اسحب الملفات',
  'decrypt.upload.hint': 'يدعم ملفات .encrypted، الحد الأقصى {maxSize} لكل ملف',
  'decrypt.upload.button.decrypt': 'فك تشفير المحدد',
  'decrypt.upload.button.clear': 'مسح القائمة',
  'decrypt.fileList.empty': 'لا توجد ملفات، يرجى إضافة ملفات لفك تشفيرها',
  'decrypt.fileList.column.name': 'اسم الملف',
  'decrypt.fileList.column.size': 'الحجم',
  'decrypt.fileList.column.status': 'الحالة',
  'decrypt.fileList.column.actions': 'الإجراءات',
  'decrypt.fileList.status.pending': 'قيد الانتظار',
  'decrypt.fileList.status.decrypting': 'جاري فك التشفير',
  'decrypt.fileList.status.success': 'تم الإكمال',
  'decrypt.fileList.status.error': 'خطأ',
  'decrypt.fileList.action.info': 'معلومات',
  'decrypt.password.modal.title': 'أدخل كلمة مرور فك التشفير',
  'decrypt.password.modal.placeholder': 'أدخل كلمة المرور',
  'decrypt.password.modal.hint': 'أدخل كلمة المرور التي تم تعيينها أثناء التشفير، سيتم استخدامها فقط لفك التشفير المحلي',
  'decrypt.security.modal.title': 'إشعار الأمان',
  'decrypt.security.modal.description': 'تتم جميع عمليات فك التشفير محلياً، لن يتم إرسال كلمة المرور ومحتوى الملف إلى الخادم أبداً',
  'decrypt.security.modal.vip.title': 'كمستخدم VIP، يمكنك:',
  'decrypt.security.modal.vip.feature1': 'فك تشفير الملفات من أي حجم',
  'decrypt.security.modal.vip.feature2': 'استخدام فك التشفير الذكي بالكتل لكفاءة أفضل',
  'decrypt.security.modal.vip.feature3': 'دعم فك تشفير دفعي للملفات الكبيرة',
  'decrypt.security.modal.free.title': 'هام: تتطلب عملية فك التشفير حوالي 3 أضعاف حجم الملف في ذاكرة المتصفح.',
  'decrypt.security.modal.free.feature1': 'المستخدمون المجانيون محدودون بـ 4GB لكل ملف',
  'decrypt.security.modal.free.feature2': 'قم بالترقية إلى VIP لفك تشفير الملفات من أي حجم',
  'decrypt.security.modal.free.feature3': 'إذا تعطل المتصفح، فكر في الترقية إلى VIP لاستخدام فك التشفير بالكتل',
  'decrypt.message.invalidFile': 'يرجى اختيار ملفات .encrypted فقط',
  'decrypt.message.duplicate': 'الملف "{filename}" موجود بالفعل، تمت إزالة النسخة المكررة تلقائياً',
  'decrypt.message.oversizeTitle': 'تم تجاوز حجم الملف',
  'decrypt.message.oversizeContent': 'الملفات التالية تتجاوز الحد المجاني (4GB):',
  'decrypt.message.oversizeHint': 'قم بالترقية إلى VIP لفك تشفير الملفات من أي حجم',
  'decrypt.message.selectFile': 'يرجى اختيار الملفات لفك تشفيرها',
  'decrypt.message.enterPassword': 'يرجى إدخال كلمة مرور فك التشفير',
  'decrypt.message.decryptSuccess': 'تم حفظ الملف {filename}',
  'decrypt.message.saveCancel': 'تم إلغاء حفظ الملف {filename}',
  'decrypt.message.downloadSuccess': 'تم حفظ الملف {filename} في مجلد التنزيلات',
  'decrypt.message.decryptError': 'خطأ في فك تشفير الملف {filename}: {error}',
  'decrypt.message.batchError': 'فشل فك التشفير الدفعي، يرجى المحاولة مرة أخرى',
  'security.features.title': 'ميزات الأمان',
  'security.features.localDecryption.title': 'فك التشفير المحلي',
  'security.features.localDecryption.description': 'تتم جميع عمليات فك التشفير محلياً في متصفحك، لا يغادر محتوى الملف وكلمة المرور جهازك أبداً',
  'security.features.militaryEncryption.title': 'تشفير عسكري',
  'security.features.militaryEncryption.description': 'يستخدم خوارزمية تشفير AES-256-CBC، معيار التشفير المتماثل الأكثر أماناً الذي يمكنه مقاومة جميع الهجمات المعروفة',
  'security.features.privacyProtection.title': 'حماية الخصوصية',
  'security.features.privacyProtection.description': 'آلية صارمة لحماية الخصوصية، لا يتم حفظ كلمات مرور فك التشفير، لا يتم تسجيل محتوى الملفات',
  'security.features.smartDecryption.title': 'فك التشفير الذكي بالكتل',
  'security.features.smartDecryption.description': 'تقنية فك التشفير الذكي بالكتل تحسن سرعة فك التشفير بشكل كبير مع تقليل استخدام الذاكرة',
  'security.features.learnMore': 'معرفة المزيد',
  'security.diagram.plaintext.block1': 'كتلة النص العادي 1',
  'security.diagram.plaintext.block2': 'كتلة النص العادي 2',
  'security.diagram.ciphertext.block1': 'كتلة النص المشفر 1',
  'security.diagram.ciphertext.block2': 'كتلة النص المشفر 2',
  'security.diagram.key': 'المفتاح',
  'security.diagram.aes.encryption': 'تشفير AES',
  'security.diagram.xor.operation': 'عملية XOR',
  'security.diagram.iv': 'متجه التهيئة',
  'common.unknown': 'غير معروف',
  'common.speed': 'السرعة',
  'common.timeSpent': 'الوقت المستغرق',
  'common.remaining': 'المتبقي',
  'sideMenu.storageInfo.title': 'مساحة التخزين',
  'sideMenu.storageInfo.usage': 'مستخدم {used} / الإجمالي {total}',
  'sideMenu.storageStats.title': 'إحصائيات التخزين',
  'sideMenu.storageStats.overview': 'نظرة عامة',
  'sideMenu.storageStats.totalFiles': 'إجمالي الملفات',
  'sideMenu.storageStats.totalSize': 'الحجم الإجمالي',
  'sideMenu.storageStats.fileTypes': 'توزيع أنواع الملفات',
  'sideMenu.storageStats.providers': 'مزودي الخدمة',
  'common.default': 'افتراضي',
  'common.regionCode': 'رمز المنطقة',
  'common.nodeType': 'نوع العقدة',
  'common.storageUsed': 'المساحة المستخدمة',
  'common.storageAvailable': 'المساحة المتاحة',
  'common.storageLimit': 'السعة الإجمالية',
  'common.storageUsageDetail': 'مستخدم {used} / الإجمالي {total}',
  'common.defaultNode': 'العقدة الافتراضية',
  'common.confirm': 'تأكيد',
  'common.cancel': 'إلغاء',
  'common.latency': 'زمن الاستجابة',
  'common.retry': 'إعادة المحاولة',
  'cloudDrive.nodeSelect.title': 'اختيار عقدة التخزين',
  'cloudDrive.nodeSelect.addNode': 'إضافة عقدة تخزين',
  'cloudDrive.nodeSelect.deleteConfirm.title': 'تأكيد حذف العقدة',
  'cloudDrive.nodeSelect.deleteConfirm.content': 'هل أنت متأكد من حذف العقدة "{nodeName}"؟ لا يمكن التراجع عن هذا الإجراء!',
  'cloudDrive.nodeSelect.deleteSuccess': 'تم حذف العقدة بنجاح',
  'cloudDrive.nodeSelect.deleteFailed': 'فشل حذف العقدة',
  
  // إنشاء العقدة
  'cloudDrive.nodeCreate.title': 'إضافة عقدة تخزين',
  'cloudDrive.nodeCreate.selectProvider': 'اختر مزود السحابة',
  'cloudDrive.nodeCreate.nodeName': 'اسم العقدة',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': 'اترك فارغاً لاستخدام الاسم الافتراضي',
  'cloudDrive.nodeCreate.nameMaxLength': 'لا يمكن أن يتجاوز اسم العقدة 50 حرفاً',
  'cloudDrive.nodeCreate.noProviders': 'لا يوجد مزودي سحابة متاحين',
  'cloudDrive.nodeCreate.pingLatency': 'زمن الاستجابة {value} مللي ثانية',
  'cloudDrive.nodeCreate.pingTesting': 'جارٍ اختبار زمن الاستجابة...',
  'cloudDrive.nodeCreate.pingFailed': 'فشل اختبار زمن الاستجابة',
  'cloudDrive.nodeCreate.pingUnavailable': 'اختبار زمن الاستجابة غير متاح',
  'cloudDrive.nodeCreate.sortByLatency': 'ترتيب حسب زمن الاستجابة',
  'cloudDrive.nodeCreate.selectRegion': 'اختيار المنطقة',
  'cloudDrive.nodeCreate.selectedRegion': 'المنطقة المحددة',
  'cloudDrive.nodeCreate.noRegions': 'لا توجد مناطق متاحة',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': 'يرجى اختيار مزود السحابة',
  'cloudDrive.nodeCreate.selectProviderRequired': 'يرجى اختيار مزود السحابة أولاً',
  'cloudDrive.nodeCreate.selectRegionRequired': 'يرجى اختيار المنطقة أولاً',
  'cloudDrive.nodeCreate.loadProvidersFailed': 'فشل تحميل قائمة مزودي السحابة',
  'cloudDrive.nodeCreate.loadRegionsFailed': 'فشل تحميل قائمة المناطق',
  'cloudDrive.nodeCreate.nodeType': 'نوع العقدة',
  'cloudDrive.nodeCreate.nodeType.standard': 'تخزين قياسي',
  'cloudDrive.nodeCreate.nodeType.lowFreq': 'تخزين منخفض التردد',
  'cloudDrive.nodeCreate.nodeType.archive': 'تخزين الأرشيف',
  'cloudDrive.nodeCreate.storageLimit': 'حد التخزين',
  'cloudDrive.nodeCreate.storageLimitRequired': 'يرجى إدخال حد التخزين',
  'cloudDrive.nodeCreate.storageLimitMin': 'لا يمكن أن يكون حد التخزين أقل من 1 جيجابايت',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': 'أدخل حد التخزين (جيجابايت)',
  'cloudDrive.nodeCreate.success': 'تم إنشاء عقدة التخزين بنجاح',
  'cloudDrive.nodeCreate.failed': 'فشل إنشاء عقدة التخزين',
  
  // تحرير العقدة
  'cloudDrive.nodeEdit.title': 'تحرير العقدة',
  'cloudDrive.nodeEdit.name': 'اسم العقدة',
  'cloudDrive.nodeEdit.nameRequired': 'يرجى إدخال اسم العقدة',
  'cloudDrive.nodeEdit.nameMaxLength': 'لا يمكن أن يتجاوز اسم العقدة 50 حرفاً'
}; 